const validations = {
  mustBeNumber: "Dit veld moet een getal zijn",
  mustBePositive: "Dit veld moet een positief getal zijn",
  required: "Dit veld is verplicht",
  mustBeEmail: "Dit veld moet een geldig e-mailadres zijn",
  mustBeDate: "Dit veld moet een geldige datum zijn",
};

export default validations;
